import { Pane, Position, Tooltip, majorScale } from 'evergreen-ui';
import React, { FC } from 'react';

import { DeprecationBanner } from './deprecation-banner.component';
import GarnerWordmark from 'jsx:../assets/images/garner-wordmark.svg';
import { IoHelpCircle } from 'react-icons/io5';
import { SignOutButton } from './sign-out.component';

export const RootLayout: FC = ({ children }) => (
  <Pane minHeight="100vh">
    <Pane
      is="header"
      height={majorScale(5)}
      background="#006b59"
      paddingX={10}
      display="grid"
      alignItems="center"
      gridTemplateColumns="1fr auto auto"
      gap="15px"
    >
      <GarnerWordmark height={24} color="#FFFFFF" />
      <Tooltip
        content="Please reach out to your Account Manager with any issues or questions."
        position={Position.BOTTOM}
      >
        <Pane display="flex" color="white">
          <span style={{ display: 'grid', marginRight: '8px' }}>
            <IoHelpCircle fontSize={'24px'} />
          </span>
          Support
        </Pane>
      </Tooltip>
      <SignOutButton />
    </Pane>
    <DeprecationBanner />
    {children}
  </Pane>
);
